import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { Select } from '@bingads-webui-react/primitive-with-signal';
import { LineByLineFormGroup } from '@bingads-webui-cc-react/layout';

export const selectOptions = options => options.map(({ id, value }) => <option key={id} value={id}>{value}</option>);

export class TimeZone extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      countryCode: this.props.countryCode,
      timeZone: this.props.timeZone,
      timeZones: _.map(this.props.timeZones, timeZone => ({
        id: timeZone.Value,
        value: timeZone.Text,
      })),
    };
  }

  componentDidMount() {
    this.onUpdateTimeZones(this.state.countryCode);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.countryCode !== this.state.countryCode) {
      this.setState({
        countryCode: nextProps.countryCode,
      });

      this.onUpdateTimeZones(nextProps.countryCode);
    }
  }

  onChange = (timeZone) => {
    this.setState({ timeZone }, () => this.props.onTimeZoneChange(this.state.timeZone));
  };

  onUpdateTimeZones = (countryCode) => {
    let filteredTimeZones = this.props.timeZones;
    if (countryCode && !_.isEmpty(countryCode)) {
      const availableTimeZones = _.findWhere(this.props.timeZonesPerCountryMapping, { country: countryCode });
      if (availableTimeZones && !_.isEmpty(availableTimeZones) && !_.isEmpty(availableTimeZones.timeZones)) {
        filteredTimeZones = _.filter(filteredTimeZones, timeZone => _.contains(availableTimeZones.timeZones, Number(timeZone.Value)));
      }
    }
    if (_.isEmpty(filteredTimeZones)) {
      filteredTimeZones = this.props.timeZones;
    }

    this.setState({
      timeZones: _.map(filteredTimeZones, timeZone => ({
        id: timeZone.Value,
        value: timeZone.Text,
      })),
      // FIXME: add eslint disable line to temporarily pass auto upgrade, THIS SHOULD BE FIXED
      filteredTimeZones, // eslint-disable-line react/no-unused-state
    });

    const selectedItem = _.findWhere(filteredTimeZones, { Value: this.state.timeZone });
    this.onChange(selectedItem ? selectedItem.Value : _.first(filteredTimeZones).Value);
  };

  render() {
    const { isReadonly } = this.props;
    const timeZoneList = this.state.timeZones;
    const selectedItem = _.findWhere(timeZoneList, { id: this.state.timeZone });
    const defaultDisplay = selectedItem ? selectedItem.value : _.first(timeZoneList).value;
    const label = this.props.i18n.getString(_TL_('Preferred time zone'));

    return (
      <div className="time-zone-component">
        <LineByLineFormGroup
          id={`${this.props.id}_TimeZoneFormGroup`}
          label={label}
          helpPopupTopic={this.props.helpPopupId.length !== 0 ? this.props.helpPopupId : 'Page_Accounts_Details_Edit_TimeZone'}
          helpPopupAriaLabel={this.props.helpPopupAriaLabel || this.props.i18n.getString(_TL_('Preferred time zone tooltip'))}
        >
          {isReadonly && defaultDisplay}
          {!isReadonly &&
            <Select
              value={selectedItem ? selectedItem.id : _.first(timeZoneList).id}
              onChange={({
                target: { value: newValue },
              }) => this.onChange(newValue)}
              key="TimeZone"
              name="TimeZone"
              aria-label={label}
            >
              {selectOptions(timeZoneList)}
            </Select>
          }
        </LineByLineFormGroup>
      </div>
    );
  }
}

TimeZone.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  id: PropTypes.string.isRequired,
  countryCode: PropTypes.string,
  timeZone: PropTypes.string,
  onTimeZoneChange: PropTypes.func.isRequired,
  timeZones: PropTypes.arrayOf(PropTypes.shape({
    Value: PropTypes.string.isRequired,
    Text: PropTypes.string.isRequired,
  })).isRequired,
  timeZonesPerCountryMapping: PropTypes.arrayOf(PropTypes.shape({
    country: PropTypes.string.isRequired,
    timeZones: PropTypes.arrayOf(PropTypes.number.isRequired),
  })),
  helpPopupId: PropTypes.string,
  helpPopupAriaLabel: PropTypes.string,
  isReadonly: PropTypes.bool,
};

TimeZone.defaultProps = {
  countryCode: '',
  timeZone: '0',
  timeZonesPerCountryMapping: [],
  helpPopupId: '',
  helpPopupAriaLabel: '',
  isReadonly: false,
};
